// extracted by mini-css-extract-plugin
module.exports = {"errorMessage":"errorMessage--2afMk","errorText":"errorText--3WOOV"};